import { urlService } from 'core-utilities';
import searchResultLayout from '../constants/searchResultLayoutConstants';

const getKeyword = () => {
  const { searchQueryParamName } = searchResultLayout;
  const currentUrl = window?.location?.search ?? '';
  const queries = urlService.parseQueryString(currentUrl.toLowerCase());
  return queries ? queries[searchQueryParamName] : null;
};

const getSession = () => {
  const { searchQueryParamName } = searchResultLayout;
  const currentUrl = window?.location?.search ?? '';
  const queries = urlService.parseQueryString(currentUrl.toLowerCase());
  return queries ? queries[searchQueryParamName] : null;
};

export default { getKeyword, getSession };
